<form [formGroup]="questionForm">
    <div class="add__question--left--content">
        <acengage-text-input [inputType]="'text'" [maxLength]="null"
            [placeholder]="'Enter the question here *'" formControlName="question">
        </acengage-text-input>
        <acengage-form-error [control]="questionForm.controls['question']" validatorName="required">
            Question is required.
        </acengage-form-error>
    </div>
</form>    